import { AiChatContext } from '@/features/AiChat/model/context/context';
import { PropsWithChildren } from 'react';
import { useChatService } from '@/features/AiChat/model/services/use-chat-service.ts';

const AiChatContextProvider = (props: PropsWithChildren) => {
  const {
    children
  } = props;
  const service = useChatService();

  return (
    <AiChatContext.Provider value={service}>
      {children}
    </AiChatContext.Provider>
  );
};

export default AiChatContextProvider;